import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=4f2500fa&scoped=true&"
import script from "./Home.vue?vue&type=script&lang=js&"
export * from "./Home.vue?vue&type=script&lang=js&"
import style0 from "../../static/scss/home.scss?vue&type=style&index=0&id=4f2500fa&scoped=true&lang=scss&"
import style1 from "./Home.vue?vue&type=style&index=1&id=4f2500fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2500fa",
  null
  
)

export default component.exports